module.exports = import("https://esm.sh/@ffmpeg/ffmpeg@0.12.10");;